module.exports = __webpack_public_path__ + "static/img/slide_8_en.7c4dee5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_8_en.svg
// module id = 2noi
// module chunks = 0